'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _adminsByCategoryBar = require('./admins-by-category-bar.html');

var _adminsByCategoryBar2 = _interopRequireDefault(_adminsByCategoryBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _adminsByCategoryBar2.default,
  controller: function () {
    function AdministrationsByCategoryBarComponent($scope, LoadingService, AdminsByCategoryBarService, ToastService) {
      'ngInject';

      _classCallCheck(this, AdministrationsByCategoryBarComponent);

      Object.assign(this, {
        $scope: $scope,
        LoadingService: LoadingService,
        AdminsByCategoryBarService: AdminsByCategoryBarService,
        ToastService: ToastService
      });

      // window.Highcharts.theme = {
      //   colors: ['#f45b5b', '#8085e9', '#8d4654', '#7798BF', '#aaeeee',
      //     '#ff0066', '#eeaaee', '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'],
      //   chart: {
      //     backgroundColor: null,
      //     style: {
      //       fontFamily: 'Signika, serif'
      //     }
      //   },
      //   title: {
      //     style: {
      //       color: 'black',
      //       fontSize: '16px',
      //       fontWeight: 'bold'
      //     }
      //   },
      //   subtitle: {
      //     style: {
      //       color: 'black'
      //     }
      //   },
      //   tooltip: {
      //     borderWidth: 0
      //   },
      //   legend: {
      //     itemStyle: {
      //       fontWeight: 'bold',
      //       fontSize: '13px'
      //     }
      //   },
      //   xAxis: {
      //     labels: {
      //       style: {
      //         color: '#6e6e70'
      //       }
      //     }
      //   },
      //   yAxis: {
      //     labels: {
      //       style: {
      //         color: '#6e6e70'
      //       }
      //     }
      //   },
      //   plotOptions: {
      //     series: {
      //       shadow: true
      //     },
      //     candlestick: {
      //       lineColor: '#404048'
      //     },
      //     map: {
      //       shadow: false
      //     }
      //   },

      //   // Highstock specific
      //   navigator: {
      //     xAxis: {
      //       gridLineColor: '#D0D0D8'
      //     }
      //   },
      //   rangeSelector: {
      //     buttonTheme: {
      //       fill: 'white',
      //       stroke: '#C0C0C8',
      //       'stroke-width': 1,
      //       states: {
      //         select: {
      //           fill: '#D0D0D8'
      //         }
      //       }
      //     }
      //   },
      //   scrollbar: {
      //     trackBorderColor: '#C0C0C8'
      //   },

      //   // General
      //   background2: '#E0E0E8'
      // };
      // window.Highcharts.setOptions(window.Highcharts.theme);
    }

    _createClass(AdministrationsByCategoryBarComponent, [{
      key: 'getChartConfig',
      value: function getChartConfig() {
        return {
          chart: {
            type: 'column',
            inverted: true,
            marginLeft: 225,
            zoomType: 'xy'
          },
          title: {
            text: 'Administrations by Product Category'
          },
          subtitle: {
            text: 'NASC Adverse Event Reporting System'
          },
          xAxis: [{
            type: 'category',
            title: {
              style: {
                fontSize: '14px'
              }
            },
            labels: {
              style: {
                fontSize: '14px'
              }
            }
          }],
          yAxis: [{
            title: {
              text: 'Administrations (mils)',
              style: {
                color: window.Highcharts.getOptions().colors[1],
                fontSize: '14px'
              }
            },
            labels: {
              format: '{value}',
              style: {
                color: window.Highcharts.getOptions().colors[1],
                fontSize: '14px'
              }
            }
          }],
          legend: {
            align: 'center',
            itemStyle: {
              fontSize: '14px'
            }
          },
          plotOptions: {
            pie: {
              size: 500,
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '{point.name}: {point.percentage:.1f}%',
                style: {
                  fontSize: '14px'
                }
              },
              showInLegend: true
            },
            column: {
              stacking: 'normal',
              align: 'top',
              pointPadding: 0,
              groupPadding: 0.1,
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y:,.2f}'
              }
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:,.2f} mil</b></td></tr>',
            footerFormat: '</table>',
            split: true,
            useHTML: true
          }
        };
      }
    }, {
      key: '$onInit',
      value: function $onInit() {
        this.chartConfig = this.getChartConfig();
      }
    }, {
      key: 'generateReport',
      value: function generateReport(_ref) {
        var _this = this;

        var params = _ref.params;

        this.LoadingService.start();
        this.AdminsByCategoryBarService.getReport(params).then(function (_ref2) {
          var series = _ref2.series,
              drilldown = _ref2.drilldown;

          _this.chartConfig = undefined;
          _this.$scope.$apply();
          _this.chartConfig = _this.getChartConfig();
          _this.chartConfig.series = series;
          _this.chartConfig.drilldown = drilldown;
        }).catch(function (error) {
          return _this.ToastService.showError(error);
        }).finally(function () {
          _this.LoadingService.stop();
          _this.$scope.$apply();
        });
      }
    }]);

    return AdministrationsByCategoryBarComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/reports/admins-by-category-bar/admins-by-category-bar.component.js